<template>
	<div>
		<CModal title="Ajouter un paiement" size="lg" :show.sync="showModal" :key="key">
			<template v-if="loading">
				<Loading />
			</template>
			<template v-else>
				<CInput
					type="number"
					label="Montant du paiment"
					name="amount"
					ref="amount"
					:value="this.remainingToPay"
					min="0"
					:max="this.remainingToPay" />
				<CSelect
					label="Methode de paiement"
					:options="paymentOptions"
					name="paymentMethod"
					:value.sync="paymentMethod" />
				<CTextarea
					row="40"
					col="6"
					label="Informations complémentaires sur le paiement"
					placeholder="numéro de chèque, référence du virement, raison, note..."
					v-model="additionalInfo"
					:isValid="isValidAdditionalInfo"
					:invalid-feedback="errorAdditionalInfo"
					ref="additionalInfo" />
			</template>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit">Appliquer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import Loading from '@/components/loading';
	export default {
		components: { Loading },
		props: {
			order: Object,
			payments: Array,
		},

		data() {
			return {
				loading: true,
				key: 0,
				showModal: false,
				errorAdditionalInfo: '',
				additionalInfo: null,
				paymentMethod: null,
				contactChannel: 'order.contact_channel.show_room',
				paymentOptions: [],
			};
		},

		computed: {
			isValidAdditionalInfo() {
				if (
					(this.additionalInfo === null || this.additionalInfo === '') &&
					[
						'payment.check',
						'payment.bank_transfer',
						'payment.free',
						'payment.gift',
						'payment.tpe',
					].includes(this.paymentMethod)
				) {
					return false;
				}

				if (this.additionalInfo !== '0200871') {
					return false;
				}

				return true;
			},
			remainingToPay() {
				if (this.order === null) {
					return 0;
				}

				return (
					parseFloat(this.order.priceTotal) -
					this.payments.reduce((acc, el) => acc + parseFloat(el.amount), 0)
				);
			},
		},

		watch: {
			paymentMethod(newValue) {
				if (newValue === 'payment.bank_transfer') {
					this.errorAdditionalInfo = 'Veuillez saisir la référence du virement';
				} else if (newValue === 'payment.check') {
					this.errorAdditionalInfo = 'Veuillez saisir le numéro du chèque';
				} else if (newValue === 'payment.tpe') {
					this.errorAdditionalInfo = 'Veuillez saisir le code TPE';
				} else if (newValue === 'payment.free' || newValue === 'payment.gift') {
					this.errorAdditionalInfo = 'Veuillez saisir une raison';
				} else if (newValue === 'payment.credit_note') {
					this.errorAdditionalInfo =
						'Veuillez saisir le motif du remboursement et le numéro de bordereau/colis.';
				} else {
					this.errorAdditionalInfo = '';
				}
			},

			showModal(newVal) {
				if (newVal === true) {
					this.$axios.get(this.order['@id'] + '/order_items').then(res => {
						this.loading = false;

						// check if depot point is colipays
						for (let item of res.data['hydra:member']) {
							if (
								item.slip &&
								((item.slip.depotPts &&
									item.slip.depotPts['@id'] === '/api/point_of_sales/1') ||
									(item.slip.salePts &&
										item.slip.salePts['@id'] === '/api/point_of_sales/1'))
							) {
								this.paymentOptions = [
									{
										label: 'Carte bleu (TPE)',
										value: 'payment.tpe',
									},
									{
										label: 'Espèces',
										value: 'payment.cash',
									},
									{
										label: 'Chèque',
										value: 'payment.check',
									},
									{
										label: 'Virement',
										value: 'payment.bank_transfer',
									},
									{
										label: 'Avoir',
										value: 'payment.credit_note',
									},
									{
										label: 'Gratuit',
										value: 'payment.free',
									},
									{
										label: 'Cadeau',
										value: 'payment.gift',
									},
									{
										label: 'Réexpédition',
										value: 'payment.reshipment',
									},
									{
										label: 'Revendeur',
										value: 'payment.dealer',
									},
									{
										label: 'Règlement ancien B.O.',
										value: 'payment.older_backoffice',
									},
								];

								// set default payment method
								this.paymentMethod = 'payment.tpe';

								return true;
							}
						}

						this.paymentOptions = [
							{
								label: 'Revendeur',
								value: 'payment.dealer',
							},
							{
								label: 'Avoir',
								value: 'payment.credit_note',
							},
							{
								label: 'Gratuit',
								value: 'payment.free',
							},
						];

						// set default payment method
						this.paymentMethod = 'payment.dealer';
					});
				}
			},
		},

		methods: {
			onSubmit() {
				if (
					this.paymentMethod !== 'payment.credit_note' &&
					parseFloat(this.$refs.amount.state) > this.remainingToPay
				) {
					this.$toast.error(
						`Vous avez saisi un montant plus élevé que le reste à payer de ${this.remainingToPay} €.`
					);
					return false;
				}

				if (
					this.paymentMethod === 'payment.tpe' &&
					(!this.additionalInfo || this.additionalInfo !== '0200871')
				) {
					this.$toast.error('Le code TPE saisi est incorrect.');
					return false;
				}

				if (this.paymentMethod === 'payment.credit_note' && !this.additionalInfo) {
					this.$toast.error(
						'Veuillez saisir le motif du remboursement et le numéro de bordereau/colis.'
					);
					return false;
				}

				this.$axios
					.post('/api/payments', {
						order: this.order['@id'],
						method: this.paymentMethod,
						additionalInfo: this.additionalInfo,
						amount: parseFloat(this.$refs.amount.state),
					})
					.then(res => {
						if (this.paymentMethod === 'payment.credit_card') {
							window.location = res.data.bankCardPaymentURL;
						} else {
							this.$emit('refresh');
						}
						this.showModal = false;
						this.key++;
					})
					.catch(err => {
						this.$toast.error(err.response.data['hydra:description']);
					});
			},
		},
	};
</script>

<style>
	.form-control.is-valid {
		border: 1px solid #d8dbe0;
		background-image: none;
	}
</style>
